import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCartContext } from '../Context/CartContext';
import ItemCart from '../ItemCart/ItemCart';
import Button from 'react-bootstrap/Button';
import { Offcanvas } from 'react-bootstrap'; // ✅ Importamos correctamente
import imgCarro from "../../Imagenes/carrovacio.png";
import imgCarro1 from "../../Imagenes/carroleno.png";
import toast, { Toaster } from 'react-hot-toast';
import "../CartWidget/CartWidget.css";
import { useNavigate } from 'react-router-dom';


const CartWidget = ({ selectedSize, acomp }) => {
    const { totalProducts, cart, totalPrice, moduloBebida } = useCartContext();
    const [show, setShow] = useState(false);
    const [iconCart, setIconCart] = useState(totalProducts === 0 ? imgCarro : imgCarro1);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();

    const handleRealizarPedido = () => {
        handleClose();
        navigate("/checkout");
      };

    useEffect(() => {
        setIconCart(totalProducts() === 0 ? imgCarro : imgCarro1);
    }, [totalProducts]);


// Dentro de CartWidget
const totalViandas = cart.reduce((acc, item) => acc + item.quantity, 0);


    return (
        <>  
            <div className="estilo-cart mood" onClick={handleShow}>
                <img src={iconCart} style={{ width: "40px", height: "40px" }} />
                <span className='count' id="count">{totalProducts() || cart}</span>
            </div>

            {/* ✅ Offcanvas corregido */}
            <Offcanvas show={show} onHide={handleClose} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>🍽️ Mis Viandas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                    <ItemCart items={cart} moduloBebida={moduloBebida} onCloseModal={handleClose} />
                    <Toaster position="top-center" reverseOrder={false} />
                </Offcanvas.Body>
                {/* ❌ Eliminamos Offcanvas.Footer y usamos un div */}


                <div className="p-3 text-center">
  <p><b>Total del pedido: ${totalPrice()}</b></p>

  {totalViandas < 3 && (
    <p className="text-danger mt-2">⚠️ Debés elegir al menos 3 viandas para realizar el pedido.</p>
  )}

  <Button variant="secondary" onClick={handleClose} className="me-2">
    Volver
  </Button>

  <Button
  variant="dark"
  onClick={handleRealizarPedido}
  disabled={totalViandas < 3}
  title={totalViandas < 3 ? "Elegí al menos 3 viandas para continuar" : ""}
>
  Realizar pedido
</Button>
</div>
            </Offcanvas>
        </>
    );
}

export default CartWidget;
